import { section as sectionData } from "~/data";

import type { Section } from "./types";

export const AdCardIndexList = [2, 6, 9];
export const AdCardIndexSet = new Set(AdCardIndexList);

export const SubSectionList = [
  "trends",
  "luxury",
  "celeb",
  "kpop",
  "leisure",
  "well",
  "tech",
] as const;
export type SubSection = (typeof SubSectionList)[number];

export const MaximumArticleNumberPerSection = 4;

export const SectionNameMap: Record<string, Section> = {
  celeb: {
    ...sectionData.style.celebrity,
    pathname: "celeb",
  },
  kpop: {
    ...sectionData.kPop,
    pathname: "kpop",
  },
  leisure: {
    ...sectionData.style.leisure,
    pathname: "leisure",
  },
  luxury: {
    ...sectionData.style.luxury,
    pathname: "luxury",
  },
  tech: {
    ...sectionData.style.techDesign,
    pathname: "tech",
  },
  trends: {
    ...sectionData.style.newsTrends,
    pathname: "trends",
  },
  well: {
    ...sectionData.style.wellBeing,
    pathname: "well",
  },
};
